import CfdiModal from '../components/CfdiModal.vue';
import Vue from 'vue';
const cfdiModalHandler = (configs, cfdis, type, route, canCreateCFDI, onConfirmCallback) => {
  const vm = new Vue({
    ...CfdiModal,
    propsData: { configs, cfdis, type, route, canCreateCFDI, onConfirmCallback },
  });
  vm.$mount();
  vm.$bvModal.show('cfdi-handler-modal');
};
export default cfdiModalHandler;